console.log("Steps.js loaded");

class Steps {

	constructor(element) {
		this.element = element;
		this.solidColorElement = this.element.querySelector(".steps-item__solid");
		this.heightElement = this.element.querySelector(".neos-contentcollection");
		this.heightExtractElement = this.element.querySelector(".steps-item:last-child");
		this.heightAddElement = this.element.querySelector(".steps-item__no-wrapper");

		this.maxHeight = 0;
		this.init();


	}

	init() {

		window.addEventListener("scroll", () => {
			this.fixSolidHeight();
		});

		window.addEventListener("resize", () => {
			this.maxHeight = this.findMaxHeight();
			this.fixSolidHeight();
		});

		this.maxHeight = this.findMaxHeight();
		this.fixSolidHeight();
	}

	fixSolidHeight() {

		const offsetFromViewportTop = this.solidColorElement.getBoundingClientRect().top;
		const height = Math.min(Math.max(0, (window.innerHeight / 2) - offsetFromViewportTop), this.maxHeight);
		this.solidColorElement.style.height = `${height}px`;
	}

	findMaxHeight() {
		return this.heightElement.offsetHeight - this.heightExtractElement.offsetHeight + this.heightAddElement.offsetHeight;
	}
}

const stepsNodes = document.querySelectorAll(".steps-list");
const stepss = [];
[...stepsNodes].forEach(element => {
	stepss.push(new Steps(element));
});
